import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=8aa00a6e&scoped=true&"
import script from "./FloatingButton.vue?vue&type=script&lang=js&"
export * from "./FloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=8aa00a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa00a6e",
  null
  
)

export default component.exports